export const OrderStatusColors: { [key: string]: any }  = {
    waiting: '#0A69EB',
    waiting_payment : '#0A69EB',
    completed : '#75809C',
    cancelled : '#E53E3E',
    confirmed : '#0A69EB',
    dispatched : '#0A69EB',
    in_delivery : '#0A69EB',
    delivered  : '#6FAE2E',
    returned: '#E53E3E',
    returnedConfirmed: '#6FAE2E',
    returnedCancelled: '#E53E3E',
    returnedWaiting: '#0A69EB'
};
